module.exports = __webpack_public_path__ + "static/media/23.ed799309.png";